export default __webpack_public_path__ + "static/media/no-event.e4620e78.svg";